// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__e3iaG","message":"CookieConsent_message__3Vyfb","cookieLink":"CookieConsent_cookieLink__18X9V","continueBtn":"CookieConsent_continueBtn__363DP"};